import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const teacherImporterSelectors = importerSelectors(
  'teacher.importer',
)

export default teacherImporterSelectors
